// eslint-disable-next-line import/prefer-default-export
export function errorsToMessage(errors) {
  if (!Array.isArray(errors)) {
    return errors;
  }
  return errors.join('<br/>');
}
